// extracted by mini-css-extract-plugin
var _1 = "FloatingCard-module__animateUploadProgressBarWidth--ooWWy";
var _2 = "FloatingCard-module__animatedBackground--OYrjM";
var _3 = "FloatingCard-module__container--xm_to";
var _4 = "FloatingCard-module__isLoading--_P3lN";
var _5 = "FloatingCard-module__safeHoverArea--JLr2N";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "isLoading", _5 as "safeHoverArea" }
